import React from "react";
import PropTypes from "prop-types";
import { useQuery } from "@apollo/client";

import { Control, Field, Input, Label, Textarea } from "rbx";
import { EmployeeSelectAlt } from "../../../../components";
import { GET_EMPLOYEES_WITH_GROUP } from "../../../../graphql";

import "./FollowupAddEditForm.scss";
import checkMobile from "../../../../utils/checkForMobile";

const FollowupAddEditForm = ({ followup, onChange, type }) => {
  const handleInputChange = (item) => {
    onChange(item.target.name, item.target.value);
  };

  const handleDateChange = (event) => {
    onChange("followupDate", event.target.value);
  };

  const handleAssignmentChange = (name, value) => {
    onChange(name, value);
  };

  // Get employees for displaying assigned user name in edit mode
  const { data: employeesData } = useQuery(GET_EMPLOYEES_WITH_GROUP, {
    variables: {},
  });

  const employees = employeesData?.getEmployeesWithGroup || [];
  
  // Find assigned user's full name for display in edit mode
  const getAssignedUserName = () => {
    if (!followup.assignedToEmployeeNumber) return "Not assigned";
    const assignedEmployee = employees.find(emp => emp.employeeNumber === followup.assignedToEmployeeNumber);
    return assignedEmployee ? `${assignedEmployee.firstName} ${assignedEmployee.lastName}` : followup.assignedToEmployeeNumber;
  };

  const isMobile = checkMobile();
  const isEditMode = type === "Edit";

  return (
    <React.Fragment>
    <Field
      className={isMobile ? "grid-override-mobile" : "grid-override is-horizontal"}
      
      kind="group"
    >
      <Control>
        <Label>Title</Label>
        <Input
          required
          autoComplete="off"
          maxLength={50}
          name="title"
          placeholder="Title"
          type="text"
          value={followup.title || ""}
          onChange={handleInputChange}
        />
      </Control>
      <Control expanded>
        <Label>Description</Label>
        <Textarea
          autoComplete="off"
          maxLength={1000}
          name="description"
          placeholder="Description"
          type="text"
          value={followup.description || ""}
          onChange={handleInputChange}
        />
      </Control>
    </Field>

    <Field
      className={isMobile ? "grid-override-mobile" : "grid-override is-horizontal"}
      kind="group"
    >
      <Control>
        <Label>Follow-up Date</Label>
        <Input
          name="followupDate"
          placeholder="Select follow-up date"
          type="date"
          value={followup.followupDate ? new Date(followup.followupDate).toISOString().split('T')[0] : ""}
          onChange={handleDateChange}
          min={new Date().toISOString().split('T')[0]} // Prevent selecting past dates
        />
        <p style={{ fontSize: "0.875rem", color: "#666", marginTop: "0.25rem" }}>
          Date when the follow-up reminder should be sent
        </p>
      </Control>
      <Control expanded>
        {isEditMode ? (
          <React.Fragment>
            <Label>Assigned To</Label>
            <Input
              readOnly
              value={getAssignedUserName()}
              style={{ 
                backgroundColor: "#f5f5f5", 
                cursor: "not-allowed",
                color: "#666"
              }}
            />
            <p style={{ fontSize: "0.875rem", color: "#666", marginTop: "0.25rem" }}>
              Assignment cannot be changed after follow-up creation.
            </p>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <EmployeeSelectAlt
              showBlank
              label="Assign To (Optional)"
              name="assignedToEmployeeNumber"
              placeholder="Select employee to assign to"
              value={followup.assignedToEmployeeNumber || ""}
              onChange={handleAssignmentChange}
            />
            {followup.assignedToEmployeeNumber && (
              <p style={{ fontSize: "0.875rem", color: "#666", marginTop: "0.25rem" }}>
                A notification will be sent to the assigned employee when this follow-up is created.
              </p>
            )}
          </React.Fragment>
        )}
      </Control>
    </Field>
    </React.Fragment>
  );
};

FollowupAddEditForm.propTypes = {
  followup: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  type: PropTypes.string,
};

FollowupAddEditForm.defaultProps = {
  followup: {},
  type: "Create",
};

export default FollowupAddEditForm; 